import { databaseRef } from 'config'

import { getColIdFromEmail } from './getColIdFromEmail'

export const insertNewValue = (
  userId,
  userData,
  table: string,
  isTmp?: boolean
) => {
  if (isTmp) {
    return databaseRef
      .child(table)
      .child(getColIdFromEmail(userId))
      .set(userData)
  } else {
    return databaseRef
      .child(table)
      .child(userId)
      .set(userData)
  }
}



// WEBPACK FOOTER //
// ./src/store/user/insertNewValue.ts